'use client'

// Привязка личных данных localStorage к вошедшему пользователю
// (lib/user-storage.ts): на любой вход — сверка владельца, на любой выход
// (кнопка «Выйти», отказ от согласия, выход в другой вкладке) — очистка.

import { useEffect } from 'react'
import { createClient } from '@/lib/supabase/client'
import { claimUserStorage, clearUserStorage } from '@/lib/user-storage'

export function StorageOwnerSync() {
  useEffect(() => {
    const supabase = createClient()
    const { data } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'SIGNED_OUT') clearUserStorage()
      else if (session?.user?.id) claimUserStorage(session.user.id)
    })
    return () => data.subscription.unsubscribe()
  }, [])
  return null
}
